import React from 'react';
import iconClose from 'assets/svg/icon-close.svg';

type AboutInsuranceProps = {
    onClose(): void,
}

const AboutInsurance: React.FC<AboutInsuranceProps> = (props: AboutInsuranceProps) => {
    const {
        onClose
    } = props;

    return (
        <div className="about-insurance-container">
            <div className="about-insurance-top-bar">
                <a onClick={onClose}>
                    <img className="about-insurance-close" src={iconClose} />
                </a>
            </div>

            <div className="about-insurance-header">
                <h2 className="about-insurance-title biz-text">Entenda a importância do seguro</h2>
            </div>

            <div className="about-insurance-description">
                <p className="about-insurance-text">
                    O <p className="about-insurance-highlight about-insurance-text primary-text">Crédito mais seguro</p> possibilita o pagamento total ou a diminuição da sua dívida com a Biz, em situações imprevistas como a perda de renda, invalidez por acidente ou morte.
                </p>
                <p className="about-insurance-text">
                    Esse seguro é opcional e pode ser cancelado a qualquer momento. Só que neste caso, o valor pago a ser devolvido vai ser calculado de acordo com o tempo de contratação.
                </p>
            </div>

            <div className="about-insurance-rules divider-border">
                <h3 className="about-insurance-subtitle primary-text">Tipos de Cobertura</h3>

                <p className="about-insurance-topic about-insurance-text primary-text">
                    Invalidez por acidente*
                </p>
                <p className="about-insurance-text">
                    Assegura a amortização da dívida da empresa, em até R$ 500.000, caso, qualquer um dos sócios, tenha lesões físicas permanentes por causas acidentais. Não há carência ou franquia.
                </p>

                <p className="about-insurance-topic about-insurance-text primary-text">
                    Morte*
                </p>
                <p className="about-insurance-text">
                    Possibilita a quitação da dívida, em até  R$ 500.000, se a causa da morte, de qualquer um dos sócios, for natural ou acidental. Nessa situação, não existe carência ou franquia. Em caso de morte por suicídio, o pagamento só acontece se a empresa tiver contratado o seguro há mais de dois anos e não há franquia.
                </p>

                <p className="about-insurance-topic about-insurance-text primary-text">
                    Perda de renda*
                </p>
                <p className="about-insurance-text">
                    Para pessoas que atuam como  profissional liberal e/ou autônomo, por no mínimo 12 (doze) meses. Essa cobertura possibilita o pagamento de até 3 parcelas de até R$ 10 mil cada.
                </p>

                <p className="about-insurance-text about-insurance-notes">
                    *Consulte as Condições Gerais do Seguro para maiores informações.
                </p>
            </div>
        </div>
    );
}

export default AboutInsurance;
